import { resolveComponent as r, openBlock as a, createElementBlock as c, normalizeClass as s, createVNode as n } from "vue";
/* empty css                        */
import t from "../../_virtual/_plugin-vue_export-helper.js";
import d from "../../atoms/icon-loader/icon-loader.vue.js";
import l from "../../utils/mixins/theme/theme.vue.js";
const m = {
  name: "DsPlaceholderLoader",
  components: { DsIconLoader: d },
  mixins: [l]
};
function p(o, i, _, f, h, D) {
  const e = r("DsIconLoader");
  return a(), c("div", {
    class: s(["ds-placeholder-loader", `ds-placeholder-loader--${o.theme}`]),
    "data-j-loader": ""
  }, [
    n(e, {
      class: "ds-placeholder-loader__icon",
      "data-j-icon": ""
    })
  ], 2);
}
const j = /* @__PURE__ */ t(m, [["render", p]]);
export {
  j as default
};
